/*
    SYNC TO SERVER APP
*/
export interface HeartbeatPayload
{
    Counter: number;
    ServerTime: Date;
}


export class Heartbeat
{
    public IsBeating = false;
    public Counter = 0;
    public ServerTime = new Date(0);

    constructor(payload: HeartbeatPayload, isBeating: boolean)
    {
        this.Counter = payload.Counter;
        this.ServerTime = payload.ServerTime;
        this.IsBeating = isBeating;
    }
}
